import { useLayoutEffect, useRef } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { TabItem } from "@atoms"

import { ViewBarTabProps } from "./ViewBarTab.types"
import useViewBarTabs from "./ViewBarTabs.context"

export default function ViewBarTab(props: ViewBarTabProps) {
    const { value, label, phase, count, isSelected, isHidden = false, onSelect } = props

    const { registerTab, unregisterTab, activePhase, isLoading } = useViewBarTabs()
    const isDesktop = useIsDesktop()

    // The registration is keyed by value and refreshed whenever the displayed data changes, so the
    // select on mobile can be built from data the tabs own; onSelect goes through a ref so a new
    // callback identity per render doesn't re-register.
    const onSelectRef = useRef(onSelect)
    onSelectRef.current = onSelect

    useLayoutEffect(() => {
        registerTab({ value, label, phase, count, isSelected, isHidden, onSelect: () => onSelectRef.current() })
    }, [registerTab, value, label, phase, count, isSelected, isHidden])

    useLayoutEffect(() => () => unregisterTab(value), [unregisterTab, value])

    const isInActivePhase = activePhase === undefined || phase === activePhase

    if (isDesktop && isInActivePhase && !isHidden) {
        // A loading tab shows no selection, so the tab strip draws no underline under a skeleton.
        return (
            <TabItem
                count={count}
                isSelected={isSelected && !isLoading}
                onClick={onSelect}
                noDebounce={true}
                isLoading={isLoading}
            >
                {label}
            </TabItem>
        )
    } else {
        return null
    }
}
